<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Spy Hole';
                }
            },
            component_id: {
                default(){
                    return 'hardware_spy_hole';
                }
            },
            hardwareColour: {
                required: true
            },
            slab: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            hardwareKnocker: {
                required: true
            },
            securedByDesign: {
                required: true
            },
            glassDesign: {
                required: false,
                default(){
                    return '';
                }
            },
            doorRange: {
                required: true
            },
            hardwareSuite: {
                required: false,
                default(){
                    return '';
                }
            },
            doorLocation: {
                required: false,
                default(){
                    return '';
                }
            },
            extra_text: {
              default() {
                return '';
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareColour, this.hardwareHandle, this.hardwareKnocker, this.slab, this.securedByDesign, this.doorRange);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-spy-hole?hardware_colour=' + this.hardwareColour
                        + '&hardware_handle=' + this.hardwareHandle
                        + '&hardware_knocker=' + this.hardwareKnocker
                        + '&slab=' + this.slab
                        + '&secured_by_design=' + this.securedByDesign
                        + '&glass_design=' + this.glassDesign
                        + '&door_range=' + this.doorRange
                        + '&suite=' + this.hardwareSuite
                        + '&door_location=' + this.doorLocation;
            },
            cache_key(){
                return '_' + this.hardwareSuite + '_' + this.hardwareColour + '_' + this.glassDesign + '_' + this.hardwareHandle + '_' + this.hardwareKnocker + '_' + this.slab + '_' + this.securedByDesign + '_' + this.doorRange + '_' + this.doorLocation;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
